import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { CustomValidators } from 'projects/core/src/lib/validators/custom.validators';

import { ApiService } from '../../services/api.service';
import { AuthStateService } from '../../services/auth-state.service';
import { HelperService } from '../../services/helper.service';
import { UiService } from '../../services/ui.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loginForm: UntypedFormGroup;
  public errors = null;
  public loading = true;
  public busy = false;
  public messages: Array<any> = [];
  public ssoActive = false;
  public ssoRedirect: string = null;

  constructor(
    private fb: UntypedFormBuilder,
    private api: ApiService,
    private authState: AuthStateService,
    private ui: UiService,
    private transloco: TranslocoService,
    private helper: HelperService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, CustomValidators.email()]],
      password: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    const userLang = navigator.language || (navigator as any).userLanguage;
    const regex = new RegExp('de-.+');
    if (regex.test(userLang)) {
      this.helper.setLanguage('de');
    } else {
      this.helper.setLanguage('en');
    }
    this.api.init().subscribe({
      next: (result: any) => {
        this.loginForm.reset();
        this.authState.login(result.data.access_token, null);
      },
      error: (error: any) => {
        this.ssoActive = !!error.sso_active;
        this.ssoRedirect = error.sso_redirect;
      }
    }).add(() => {
      this.loading = false;
    });
  }

  public onSubmit(): void {
    this.ui.hideMessage();
    this.busy = true;
    this.api.login(this.loginForm.value.email, this.loginForm.value.password).subscribe({
      next: (result: any) => {
        this.loginForm.reset();
        this.authState.login(result.access_token, result.refresh_token);
      },
      error: (error: any) => {
        this.ui.showMessage('error', this.transloco.translate('login.error_on_login'), this.transloco.translate('common.error'));
      }
    }).add(() => {
        this.busy = false;
    });
  }

  public gotoSSO(): void {
    window.location.href = this.ssoRedirect + '&RelayState=/admin';
  }

}
